import type { ParabolicSARSettings } from "../../model";
import type { ZoomRange, CandleWithFlag } from "features/chart";
import { GRID, CANDLE_MIN_WIDTH } from "features/chart";

export function drawParabolicSAR(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  data: CandleWithFlag[],
  zoom: ZoomRange,
  values: (number | null)[],
  settings: ParabolicSARSettings,
): void {
  if (!settings.mainLine.visible) return;

  const { left, right, top, bottom } = GRID;
  const chartWidth = width - left - right;
  const chartHeight = height - top - bottom;
  const { start, end } = zoom;
  const startIdx = Math.floor(start);
  const endIdx = Math.min(Math.floor(end), data.length - 1);
  const visibleCount = Math.floor(end) - startIdx + 1;
  const cw = Math.max(CANDLE_MIN_WIDTH, chartWidth / visibleCount);

  let minPrice = Infinity, maxPrice = -Infinity;
  for (let i = startIdx; i <= endIdx; i++) {
    const c = data[i]; if (!c) continue;
    minPrice = Math.min(minPrice, c.low);
    maxPrice = Math.max(maxPrice, c.high);
  }
  if (minPrice === Infinity) return;
  const priceRange = maxPrice - minPrice || 1;
  minPrice -= priceRange * 0.05;
  maxPrice += priceRange * 0.05;
  const range = maxPrice - minPrice;
  const priceToY = (p: number) => top + ((maxPrice - p) / range) * chartHeight;

  ctx.clearRect(0, 0, width, height);
  ctx.fillStyle = settings.mainLine.color;

  const r = settings.mainLine.width + 1;

  for (let i = startIdx; i <= endIdx; i++) {
    const v = values[i];
    if (v === null) continue;
    const x = left + (i - startIdx + 0.5) * cw;
    const y = priceToY(v);
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fill();
  }
}
